import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "@redux/account";

const Component = () => {
  const navigate = useNavigate();
  const account = useAccount();

  useEffect(() => {
    account.tokenCheck((data, response) => {
      if (response.status === 200 && data.error === undefined) {
        navigate("/", { replace: true });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};

export default Component;
